import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import type { PickupParkingFacilityFeature } from '@/types/PickupParkingFacilityFeature';

interface PickupParkingFacilityDetailCardTableProps {
  data: PickupParkingFacilityFeature;
}

interface Row {
  label: string;
  value?: ReactNode;
}

export function PickupParkingFacilityDetailTable({ data }: PickupParkingFacilityDetailCardTableProps) {
  const { properties } = data;

  const rows: Row[] = [
    {
      label: 'Auslastung',
      value: properties.utilizationclass,
    },
    {
      label: 'Beleuchtung',
      value: properties.illuminated,
    },
    {
      label: 'Befestigung',
      value: properties.sealtype,
    },
    {
      label: 'Ausstattung',
      value: properties.equipmentwitingarea,
    },
    {
      label: 'Zustand',
      value: properties.measureproposal2,
    },
    {
      label: 'Bemerkungen',
      value: properties.measureproposal3,
    },
  ];

  const visibleRows = rows.filter((row) => row.value != null);

  if (!visibleRows.length) return null;

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {visibleRows.map((row) => (
            <TableRow key={row.label}>
              <TableCell sx={{ wordBreak: 'break-word', hyphens: 'auto', width: 160 }}>
                <Typography lang="de" variant="caption">
                  {row.label}
                </Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: 'pre-line' }}>
                <Typography variant="body2">{row.value}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
